// extracted by mini-css-extract-plugin
export default {"listCard":"listcard_listCard__IObSJ"};